module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('contact.contact_us')))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_email')) + ":")]), _vm._v(" ntg@ufv.br"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_phones')) + ":")]), _vm._v(" (31) 3899 4097 ou (31) 3899 4086"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('contact.our_address')) + ":")]), _c('br'), _vm._v("\n        Universidade Federal de Viçosa (UFV)"), _c('br'), _vm._v("\n        Departamento de Engenharia de Produção e Mecânica (DEP)"), _c('br'), _vm._v("\n        Avenida Prof. Peter Henry Rolfs, s/n – Campus Universitário"), _c('br'), _vm._v("\n        CEP: 36570-900 – Viçosa – MG\n        "), _c('br'), _c('br'), _vm._v(" "), (_vm.formStatus === _vm.FORM_STATUS_SUBMIT_SUCCESS) ? _c('div', {
    staticClass: "alert alert-success text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.form.alerts.success')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.formStatus === _vm.FORM_STATUS_SUBMIT_ERROR) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('contact.form.alerts.error')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    class: [{
      'has-error': _vm.formData.name.error
    }, 'form-group']
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name.value),
      expression: "formData.name.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "aria-describedby": "helpBlockName"
    },
    domProps: {
      "value": (_vm.formData.name.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('name')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.name, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.name.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockName"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.name.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.email.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.email')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email.value),
      expression: "formData.email.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "aria-describedby": "helpBlockEmail"
    },
    domProps: {
      "value": (_vm.formData.email.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateEmailField('email')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.email, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.email.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockEmail"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.email.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.subject.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "subject"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.subject')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.subject.value),
      expression: "formData.subject.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "subject",
      "aria-describedby": "helpBlockSubject"
    },
    domProps: {
      "value": (_vm.formData.subject.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('subject')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.subject, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.subject.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockSubject"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.subject.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [{
      'has-error': _vm.formData.message.error
    }, 'form-group']
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.message')))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.message.value),
      expression: "formData.message.value"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "message",
      "rows": "3",
      "aria-describedby": "helpBlockMessage"
    },
    domProps: {
      "value": (_vm.formData.message.value)
    },
    on: {
      "change": function($event) {
        return _vm.validateRequiredField('message')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData.message, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formData.message.error) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlockMessage"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t(("contact.form.validation." + (_vm.formData.message.error)))) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.recaptcha_site_key
    },
    on: {
      "verify": _vm.onCaptchaVerified,
      "expired": _vm.onCaptchaExpired
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit",
      "disabled": _vm.formStatus === _vm.FORM_STATUS_SUBMITTING
    }
  }, [_vm._v(_vm._s(_vm.$t('contact.form.submit')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('gmap-map', {
    staticClass: "map",
    attrs: {
      "center": {
        lat: -20.760829,
        lng: -42.866235
      },
      "zoom": 14
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: -20.760829,
        lng: -42.865235
      },
      "clickable": false,
      "draggable": false
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db446fa2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Contact.vue
// module id = 771
// module chunks = 1